<script>
	import { fade } from "svelte/transition";
	import { createEventDispatcher } from "svelte";
	import SwitchQuestion from "./components/SwitchQuestion.svelte";
	import ChoiceQuestion from "./components/ChoiceQuestion.svelte";
	import { data } from "./store";
	import SvelteTooltip from './components/SvelteTooltip.svelte';

	const dispatcher = createEventDispatcher();

	function allFieldsNotFilled(pData) {
		const eitherEpiOrSubduFilled = pData.epiduralHematoma || pData.subduralHematoma;
		const unsureFilled = pData.unsureHematoma;

		const extraAxialHematomaFilled = pData.extraAxialHematoma !== null && ((pData.extraAxialHematoma === 'No') || (pData.extraAxialHematoma === 'Yes' && (eitherEpiOrSubduFilled || unsureFilled)))

		return pData.initialGcsScore === null || pData.initialGcsScore === -1 || pData.inappropriateUse !== 'No' || pData.largeDepressedFracture === null || !extraAxialHematomaFilled || pData.cerebralContusion === null || pData.midlineShift === null || pData.subarachnoidHemorrhage === null;
	}

</script>

<style>
	label, input[type=checkbox]  {
		display: inline;
		vertical-align: middle;
		color: black;
		font-weight: normal;
	}

	.disabledLabel {
		color: grey;
	}
</style>

<div class="p-2">
	<div class="" in:fade>
		<h5 class="mt-1 mb-2">
			Risk prediction tool for children with a GCS 13-15 head injury and
			intracranial injury on CT or MRI
		</h5>
		<div class="">
			<ChoiceQuestion bind:value={$data.largeDepressedFracture}>
				1. Does your patient have a skull fracture depressed by
				at least the width of the skull?
				<div slot="footer" class="pt-2 ml-2">
					<small>(<a
							href="#!"
							data-toggle="modal"
							data-target="#instructions-modal"
							class="card-link">click here</a>
						for measurement instructions)</small>
				</div>
			</ChoiceQuestion>
			<ChoiceQuestion bind:value={$data.midlineShift}>
				2. Does your patient have a midline shift?
			</ChoiceQuestion>

			<ChoiceQuestion bind:value={$data.extraAxialHematoma}>
				3. Does your patient have an extra-axial hematoma (i.e. either subdural or epidural hematoma)?
			</ChoiceQuestion>

			{#if $data.extraAxialHematoma === 'Yes'}
				<div class="ml-3 mb-4" id="checkboxes">
					<p class="mb-0">
						The patient's hematoma appears most likely (select more than one if multiple hematomas are present):
					</p>
					<div class="ml-3 mt-0">
						<input type="checkbox" id="epidural" bind:checked={$data.epiduralHematoma} disabled={$data.unsureHematoma}>
						<label for="epidural" class={$data.unsureHematoma ? "disabledLabel" : ""}>Epidural</label>
					</div>
					<div class="ml-3">
						<input type="checkbox" id="subdural" bind:checked={$data.subduralHematoma} disabled={$data.unsureHematoma} >
						<label for="subdural" class={$data.unsureHematoma ? "disabledLabel" : ""}>Subdural</label>
					</div>
					<div class="ml-3">
						<input type="checkbox" id="cannotDistinguish" bind:checked={$data.unsureHematoma} disabled={$data.epiduralHematoma || $data.subduralHematoma} >
						<label for="cannotDistinguish" class={$data.epiduralHematoma || $data.subduralHematoma ? "disabledLabel" : ""}>
							I cannot distinguish whether the hematoma is epidural or subdural
						</label>
					</div>
				</div>

				<!-- <ChoiceQuestion option bind:value={$data.epiduralHematoma}>
					3a. Does your patient have an epidural hematoma?
				</ChoiceQuestion>
				<ChoiceQuestion option bind:value={$data.subduralHematoma}>
					3b. Does your patient have a subdural hematoma?
				</ChoiceQuestion>
				<ChoiceQuestion option bind:value={$data.unsureHematoma}>
					3c. I am unsure if the hematoma is subdural or epidural.
				</ChoiceQuestion>			 -->
			{/if}
			
			<ChoiceQuestion bind:value={$data.cerebralContusion}>
				4. Does your patient have a cerebral contusion or intraparenchymal
				hemorrhage?
			</ChoiceQuestion>
			
			<ChoiceQuestion bind:value={$data.subarachnoidHemorrhage}>
				5. Does your patient have subarachnoid hemorrhage?
			</ChoiceQuestion>
			<ChoiceQuestion 
				bind:value={$data.initialGcsScore}
				chips={[13, 14, 15]}
			>
				6. What was your patient's initial GCS score in your emergency
				department?
			</ChoiceQuestion>
			<ChoiceQuestion
				bind:value={$data.inappropriateUse}
			>
				7. Does your patient have any of the following: bleeding
				coagulopathy, penetrating head injury, structurual brain
				lessions (e.g. brain tumors), or injuries more than 23 hours
				prior to presentation?
			</ChoiceQuestion>
		</div>
	</div>
</div>

<SvelteTooltip tip="Please fill out all the fields." bottom show={allFieldsNotFilled($data)}>
	<button
		class="btn btn-primary btn-block"
		class:btn-danger={$data.inappropriateUse === 'Yes'}
		style="border-radius: 0;"
		disabled={allFieldsNotFilled($data)}
		
		on:click={() => dispatcher('submitted')}>
		{#if $data.inappropriateUse === 'Yes'}
			This tool is not appropriate for your patient.
		{:else}View Risk Score{/if}
	</button>
</SvelteTooltip>



